<template>
    <div>
        <el-switch
            @change="onChangeBestJudgement"
            active-text="Best Judgement"
            v-model="form.best_judgement"
        >
        </el-switch>
        <el-select
            :value="value"
            @change="$emit('input', $event)"
            class="color-select"
            placeholder="Select Color"
            popper-class="color-select--popper"
            ref="select"
            v-if="!form.best_judgement"
        >
            <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in options"
            >
                <div class="float-left">{{ item.label }}</div>
                <div
                    :style="{ 'background-color': item.value }"
                    class="color-select--sample float-right"
                ></div>
                <div class="clearfix"></div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import ColorUtils from "@/utils/color";

export default {
    props: {
        value: {},
        predefine: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        bestJudgementEnabled: {
            type: Boolean,
            default: false,
        },
        bestJudgement: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            uuid: uniqid(),
            bestJudgementCheckbox: null,
            form: new Form({
                best_judgement: false,
            }),
        };
    },
    created() {},
    mounted() {
        if (this.bestJudgementEnabled) {
            this.form.best_judgement = this.bestJudgement;
        }
    },
    watch: {
        bestJudgement(value) {
            this.form.best_judgement = value;
        },
    },
    computed: {
        options() {
            return this.predefine.map((hex) => ({
                value: hex,
                label: ColorUtils.getName(hex),
            }));
        },
    },
    methods: {
        onChangeBestJudgement(value) {
            this.$emit("best-judgement-changed", value);
            if (value) {
                this.$emit("input", "#FFFFFF");
            }
        },
    },
};
</script>
